import { forwardRef, useImperativeHandle } from "react";
import { ModifyResidentRef } from "../interfaces";
import { Text } from "react-native";
import { View } from "ui/atoms/view";
import { Controller } from "react-hook-form";
import { useHandleResidentAssessments } from "../../hooks/useHandleResidentAssessments";
import UploadDocumentArea from "ui/organisms/UploadDocumentArea";
import { generalAllowedExtensions } from "app/constants/allowedExtensionsConstants";
import { validateFileExtensions } from "ui/utils/Validators";

const ResidentAssessmentFormTemplate = forwardRef<ModifyResidentRef, {}>(
  (_, ref) => {
    const { control, errorMessage, submitForm } =
      useHandleResidentAssessments();

    useImperativeHandle(
      ref,
      () => ({
        continue: () => submitForm(),
      }),
      [submitForm],
    );

    return (
      <View className="flex flex-col w-full md:w-9/12 gap-x-4 mb-7">
        <Text className="font-semibold">Other Assessments</Text>
        <Controller
          control={control}
          name="other_assessments_medias"
          defaultValue={[]}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <UploadDocumentArea
              value={value}
              onChange={onChange}
              allowedExtensions={generalAllowedExtensions}
              errorMessage={error}
            />
          )}
          rules={{
            validate: validateFileExtensions(generalAllowedExtensions),
          }}
        />

        {errorMessage ? (
          <Text className="text-red-700">{errorMessage}</Text>
        ) : null}
      </View>
    );
  },
);

ResidentAssessmentFormTemplate.displayName = "ResidentAssessmentFormTemplate";
export { ResidentAssessmentFormTemplate };
